import React, { useState, useEffect } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { sessionValidation } from "../../../services/webServices";

const BreadcrumNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(0);
  const [role, setRole] = useState("");

  const allTabs = [
    {
      label: "Summary",
      path: "/dashboard/admin-navigation/adminDashboard",
      key: "summary",
    },
    {
      label: "Projects",
      path: "/dashboard/admin-navigation/projects-list",
      key: "projects",
    },
    {
      label: "Users",
      path: "/dashboard/admin-navigation/users-list",
      key: "users",
    },
    {
      label: "Overall",
      path: "/dashboard/admin-navigation/overall",
      key: "overall",
    },
    {
      label: "Configuration",
      path: role === "admin" || role === "super_admin" ? "/dashboard/admin-navigation/admin-settings" : "/dashboard/admin-navigation/settings",
      key: "configuration",
      // admin_settings_path: "/dashboard/admin-navigation/admin-settings",
    },
    {
      label:"Mapping",
      path:"/dashboard/admin-navigation/field-mapping",
      key:"mapping",
    },
    {
      label: "Knowledge Base Management",
      path: "/dashboard/admin-navigation/knowledgebase",
      key: "kb",
    },
  ];

  // Role-based tab filtering
    const getVisibleTabs = (role) => {
    let tabs;
    switch (role) {
      case "super_admin":
        tabs = allTabs;
        break;
      case "admin":
        tabs = allTabs.filter((tab) => tab.key !== "kb");
        // Use custom path for configuration tab when role is admin
        tabs = tabs.map((tab) => 
          tab.key === "configuration" && tab.admin_settings_path
            ? { ...tab, path: tab.admin_settings_path }
            : tab
        );
        break;
      case "rag_admin":
        tabs = allTabs.filter(
          (tab) => tab.key === "kb" || tab.key === "configuration"
        );
        break;
      default:
        tabs = allTabs.filter((tab) => tab.key === "configuration");
    }
    return tabs;
  };
  const visibleTabs = getVisibleTabs(role);

  useEffect(() => {
    const fetchRole = async () => {
      try {
        const sessionResponse = await sessionValidation();
        setRole(sessionResponse?.role || "");
      } catch (error) {
        console.error("Error fetching role:", error);
        // Handle 401 error gracefully - redirect to login
        if (error.response?.status === 401) {
          navigate("/");
        }
        setRole("");
      }
    };
    fetchRole();
  }, []);

  useEffect(() => {
    // When location changes, update tab index if it matches
    const index = visibleTabs.findIndex(
      (tab) => tab.path === location.pathname
    );
    if (index !== -1) setValue(index);
  }, [location.pathname, visibleTabs]);

  const handleChange = (event, newValue) => {
    navigate(visibleTabs[newValue].path);
  };

  return (
    <Box>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          mt: 1,
          mb: 2,
          bgcolor: "#ffffff",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="navigation tabs"
        >
          {visibleTabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              sx={{ textTransform: "none", fontSize: "1rem", mx: 2 }}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  );
};

export default BreadcrumNav;